import Vue, { PropType } from 'vue';

import style from "./css/TopMenu.module.css";

interface IMenuButton {
  label: string;
  onClick: () => void;
  imgSrc?: string;
  highlight?: boolean;
}

interface IData {
  optionSelected: boolean;
}

export type MobileMenuButtonList = Array<IMenuButton>;

export default Vue.extend({
  data(): IData {
    return {
      optionSelected: false,
    };
  },
  props: {
    open: Boolean,
    options: Array as PropType<MobileMenuButtonList>,
  },
  render() {
    const isHighlight = (option: IMenuButton) => Boolean(option.highlight); 
    return (
      <div class={this.open ? style.mobileMenuOpen : style.mobileMenu}>
        { this.options.map((option, index, arr) => (
          <div>
            <div
              class={isHighlight(option) ? style.buttonHighlight : style.button}
              
              // when button clicked wait until animation has been shown
              onClick={() => {
                if (this.optionSelected) return;
                this.optionSelected = true;
                
                setTimeout(() => {
                  option.onClick();
                  // reset when click performed
                  this.optionSelected = false;
                }, 300);
              }}>

              {option.imgSrc
                ? <img class={style.buttonIcon} src={option.imgSrc} />
                : null}

              <div class={style.buttonLabel}>{option.label}</div>
            </div>

            { index < arr.length
              ? <div class={style.separator}></div>
              : null}
          </div>
        ))}
      </div>
    );
  },
});
